import {Injectable} from '@angular/core';
import {BehaviorSubject, combineLatestWith, Observable} from 'rxjs';
import {filter, map, take} from 'rxjs/operators';
import * as R from 'ramda';
import * as RA from 'ramda-adjunct';

import {ManagementStoreService} from './management-store.service';
import {ManagementApiService} from '@emm/management/services/management-api.service';
import {genericSort} from '@emm/core/util/sort.util';
import {GenericItem} from '@emm/core/models/context-menu-action.model';
import {Item} from '@emm/core/models/item.model';
import {Revotes} from '@emm/core/models/revotes.model';

@Injectable({
    providedIn: 'root',
})
export class MasterMenuFacadeService {

    allRevotes$ = this.api.getAllRevotes();
    categories$ = new BehaviorSubject<any>(null);
    locations$ = new BehaviorSubject<any>(null);
    revoteDetail$ = new BehaviorSubject<any>(null);
    updateRevote$ = new BehaviorSubject<any>(null);
    centerLoading$ = this.managementStore.isLoading$.masterMenu;

    rightLoading$ = this.managementStore.isLoading$.base;

    anyLoading$ = this.centerLoading$.pipe(
        combineLatestWith(this.rightLoading$),
        map((sources: boolean[]) => R.any(R.equals(true), sources))
    );

    allDTOMallFSULocations$ = this.locations$.pipe(
        map((locations) =>
            locations.map(
                (location) =>
                    ({
                        countryCode: location.countryCode,
                        description: location.description,
                        name: location.name,
                        tag: location.tag,
                        id: location.tag
                    })
            )
        )
    );

    allRevotesAsGenericItems$ = this.allRevotes$.pipe(
        filter(RA.isNotNil),
        map((revotes) =>
            revotes.sort(genericSort(a => a['name']))
                .map(
                (revote) =>
                    ({
                        name: revote.name,
                        id: revote.id,
                        disabled: false,
                        source: revote,
                    } as GenericItem<Item>)
            )
        )
    );

    constructor(private managementStore: ManagementStoreService,
                public api: ManagementApiService) {
    }

    init(): void {
        this.api.getAllLocationsMMS('MENU_ALIGNMENT').subscribe(
            (locations) => this.locations$.next(locations));
    }

    searchRevote(filterName) {
        this.managementStore.dispatch.searchRevote(filterName);
    }

    openAddDialog() {
        this.managementStore.dispatch.openAddRevoteDialog();
    }

    selectRevote(revote: Revotes) {
        this.api.getRevote(revote.id).subscribe(result => {
            this.revoteDetail$.next(result);
        })
    }

    deleteRevote(revote) {
        this.api.deleteRevote(revote.id).subscribe();
    }

    updateRevote(id: string, updates: any, dispatchReload: boolean = true): Observable<boolean> {
        this.api.updateRevote(id, updates).subscribe();
        this.updateRevote$.next(dispatchReload);
        return this.updateRevote$.pipe(take(1));
    }

    updateCategories(consumer: string) {
        this.managementStore.dispatch.updateCategories(consumer);
        this.api.getAllCategories(consumer).subscribe(categories => {
            this.categories$.next(categories);
        });
    }

    updateLocations(consumer: string) {
        this.managementStore.dispatch.updateLocations(consumer);
        this.api.getAllLocationsMMS(consumer).subscribe(locations => {
            this.locations$.next(locations);
        });
    }

    startProgressBar(): void {
        this.managementStore.dispatch.startLoading();

    }
    stopProgressBar(): void {
        this.managementStore.dispatch.stopLoading();
    }
}
